var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-view',{attrs:{"columnsFormat":_vm.columnsFormat,"askData":_vm.op_name},on:{"refreshDo":_vm.chartRefresh}})}
var staticRenderFns = []

export { render, staticRenderFns }